export default "__VITE_ASSET__aJfjoYWU__"